<template>
  <div class="user-selector">
    <div class="selected-family" v-if="modelValue">
      <UserItem :user-id="modelValue" select-mode @click="removeSelectedUser"/>
    </div>
    <div v-else>
      <AutoCompleteInput
        ref="autoCompleteInputRef"
        placeholder="Type a user name"
        :search="searchUsers"
        :item-component="UserItem"
        :get-component-props="getUserItemProps"
        @result-selected="onResultSelected">
      </AutoCompleteInput>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { User, UserSort } from '@/gp/GroupAdminModel'
import { useUserStore } from '@/gp/UserStore'
import AutoCompleteInput from '@/util/AutoCompleteInput.vue'
import UserItem from './UserItem.vue'

const props = defineProps<{
  modelValue?: string
}>()

const emit = defineEmits([
  'userSelected',
  'update:modelValue',
])

defineExpose({
  clear,
  focus,
})

interface UserSearchResult {
  value: string
  user: User
}

const autoCompleteInputRef = ref<InstanceType<typeof AutoCompleteInput>>()
const userStore = useUserStore()

function clear() {
  autoCompleteInputRef.value?.clear()
}

function focus() {
  autoCompleteInputRef.value?.focus()
}

async function searchUsers(query: string) {
  if (query.length < 3)
    return []

  const results = await userStore.searchUsersAsync({ name: query, sort: UserSort.GivenName, pageSize: 20 })
  return results.items.map(u => ({ value: u.id!, user: u }))
}

function getUserItemProps(r: { value: string }) {
  return { userId: r.value, selectMode: true }
}

function onResultSelected(r: UserSearchResult) {
  emit('userSelected', r.value)
  emit('update:modelValue', r.value)
}

function removeSelectedUser() {
  emit('update:modelValue', undefined)
}

</script>